import React from "react";
import { AuthForm } from "../../components";

const Signup = () => {
  return <AuthForm type="signup" />;
};

export default Signup;
